import { ReactComponent as FlagIcon } from "./svg/cl-flag.svg";
import "../flag-icon.scss";

export const CLFlag = () => {
  return (
    <span className="flag-icon">
      <FlagIcon />
    </span>
  );
};
